<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'User Portfolio Analysis' }}</strong>
        </div>
        <div class="col-md-1 text-right">
          <span>
            <a class="btn btn-sm btn-small btn-warning" @click.prevent="updateUserPortfolioAllocation">
              <i title="User Portfolio Allocation" class="fa fa-briefcase cwhite"></i>
            </a>
          </span>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body user-profiling">
      <vue-tabs direction="horizontal" v-model="curTab" @tab-change="getTabData" active-text-color="black">
        <v-tab title="Zero New Cash" />
        <v-tab title="With New Cash" />
        <v-tab title="With New Cash and Portfolio Changes" />
      </vue-tabs>
      <div class="d-flex align-items-center m-2">
        Date: <v-select class="col-md-4 pl-0 ml-2" :options="dateFilterTabWiseData" :placeholder="'Select Date'"
          v-model="ddate" @input="getSelDate($event)"></v-select>
        <button @click="downloadXlsFile" type="button" class="btn btn-primary">Download</button>
        <div class="w-100 d-flex justify-content-end m-2">
          <button @click="updateCronData" type="button" class="btn btn-success">Update</button>
        </div>
      </div>
      <div class="card txt-fmt" id="zeroNewCashForm1">
        <form class="form-horizontal form-cs" @onsubmit.prevent action>
          <div>
            <table class="table table-bordered fonts11 app-inner" style="table-layout:fixed;">
              <tr v-for="(tab, index) in tabsData" v-bind:key="'tab' + index">
                <th v-if="tab.value === 'profile_allocation_analysis_client'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Summary:</th>
                              <th>Output</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-if="profileAllocationAnalysisClientData.portfolio_allocation_fields_Summary"
                              v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientLblData" :key="itemLblIdx"
                              style="display: contents;">
                              <tr>
                                <td>
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs" type="text"
                                    v-model="profileAllocationAnalysisClientData[itemLbl.field][itemLbl.sub_field]" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'hubble_grable_three_factor_risk_profiling'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th v-for="(lbl, lblIdx) in hubbleGrableThreeFactorLblData" :key="lblIdx">{{ lbl.lbl
                              }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;">
                              <tr v-if="profileAllocationAnalysisClientData.portfolio_allocation_fields_Summary">
                                <td v-for="(itemLbl, subIdx) in hubbleGrableThreeFactorLblData" :key="subIdx">
                                  <!-- { lbl: "Recommendation", field: "portfolio_allocation_fields_Summary", sub_field: "recommendation" },
                                  { lbl: "Strategy", field: "portfolio_allocation_fields_Summary", sub_field: "strategy" } -->
                                  <textarea
                                    v-if="itemLbl.sub_field === 'recommendation' || itemLbl.sub_field === 'strategy'"
                                    v-model="profileAllocationAnalysisClientData[itemLbl.field][itemLbl.sub_field]"
                                    rows="2" placeholder="" style="width: 100%;" class="txt-area"></textarea>
                                  <input v-else class="new-tbl-cs" type="text"
                                    v-model="profileAllocationAnalysisClientData[itemLbl.field][itemLbl.sub_field]" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'desired_asset_allocation'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Desired Asset Allocation</th>
                              <th class="text-right">% Mix</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.desired_asset_allocation">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.desired_asset_allocation"
                                :key="itemLblIdx">
                                <td>
                                  <label>{{ itemLbl.desired_asset_field }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Mix'])" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  {{
                                    desireAssetAllocationTotal(profileAllocationAnalysisClientData.desired_asset_allocation)
                                  }}%
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'desired_alternatives'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Alternatives</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.desired_alternatives">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.desired_alternatives"
                                :key="itemLblIdx">
                                <td>
                                  <label>{{ itemLbl.desired_asset_field }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Mix'])" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  {{
                                    desireAssetAllocationTotal(profileAllocationAnalysisClientData.desired_alternatives)
                                  }}%
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'current_table'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th></th>
                              <th class="text-right">Current</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;" v-if="profileAllocationAnalysisClientData.current_table">
                              <tr v-for="(itemLbl, itemLblIdx) in currentTableLblData" :key="itemLblIdx">
                                <td>
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="profileAllocationAnalysisClientData[itemLbl.field][itemLbl.sub_field]" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'desired_vs_actual_asset_allocation'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Desired vs Actual Asset Allocation</th>
                              <th class="text-right">Desired Mix (%)</th>
                              <th class="text-right">Actual Mix (%)</th>
                              <th class="text-right">% Dev</th>
                              <th>Action Required (Y/N)</th>
                              <th>Rationale</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.desired_vs_actual_asset_allocation">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.desired_vs_actual_asset_allocation"
                                :key="itemLblIdx">
                                <td>
                                  <label>{{ itemLbl.desired_asset_field }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Mix'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Actual_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Dev'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-center" type="text"
                                    v-model="itemLbl['Action_Required_Y_N']" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Rationale']" /> -->
                                  <textarea v-model="itemLbl['Rationale']" rows="2" placeholder="" style="width: 100%;"
                                  class="txt-area"></textarea>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.desired_vs_actual_asset_allocation,
                                          '%_Mix') }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.desired_vs_actual_asset_allocation,
                                          'Actual_Mix_%', false, true) }}
                                    </strong>
                                  </label>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'desired_vs_actual_alternatives_allocation'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Desired vs Actual Alternatives Allocation</th>
                              <th class="text-right">Desired Mix (%)</th>
                              <th class="text-right">Actual Mix (%)</th>
                              <th class="text-right">% Dev</th>
                              <th>Action Required (Y/N)</th>
                              <th>Rationale</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.desired_vs_actual_alternatives_allocation">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.desired_vs_actual_alternatives_allocation"
                                :key="itemLblIdx">
                                <td>
                                  <label>{{ itemLbl.desired_asset_field }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Mix'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Actual_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Dev'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-center" type="text"
                                    v-model="itemLbl['Action_Required_Y_N']" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Rationale']" /> -->
                                  <textarea v-model="itemLbl['Rationale']" rows="2" placeholder="" style="width: 100%;"
                                  class="txt-area"></textarea>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.desired_vs_actual_alternatives_allocation,
                                          '%_Mix') }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.desired_vs_actual_alternatives_allocation,
                                          'Actual_Mix_%', false, true) }}
                                    </strong>
                                  </label>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Desired_Market_cap_allocation'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Desired Market cap Allocation</th>
                              <th class="text-right">Desired Mix (%)</th>
                              <th class="text-right">Actual Mix (%)</th>
                              <th class="text-right">% Dev</th>
                              <th>Action Required (Y/N)</th>
                              <th>Rationale</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Desired_Market_cap_allocation">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Desired_Market_cap_allocation"
                                :key="itemLblIdx">
                                <td>
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Desired_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Actual_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Dev'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-center" type="text"
                                    v-model="itemLbl['Action_Required_Y_N']" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Rationale']" /> -->
                                  <textarea v-model="itemLbl['Rationale']" rows="2" placeholder="" style="width: 100%;"
                                  class="txt-area"></textarea>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Desired_Market_cap_allocation,
                                          'Desired_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Desired_Market_cap_allocation,
                                          'Actual_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Desired_Credit_Risk_allocation'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}<span
                        style="padding-left: 0.5rem; font-size: 9pt;">- (Min AAA holding)</span></b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Desired Credit Risk Allocation<br><span
                                  style="padding-left: 0.5rem; font-size: 9pt;">(Min AAA holding)</span></th>
                              <th class="text-right align-middle">Desired Mix (%)</th>
                              <th class="text-right align-middle">Actual Mix (%)</th>
                              <th class="text-right align-middle">% Dev</th>
                              <th class="align-middle">Action Required (Y/N)</th>
                              <th class="text-center align-middle">Rationale</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Desired_Credit_Risk_allocation">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Desired_Credit_Risk_allocation"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Desired_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Actual_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Dev'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-center" type="text"
                                    v-model="itemLbl['Action_Required_Y_N']" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Rationale']" /> -->
                                  <textarea v-model="itemLbl['Rationale']" rows="2" placeholder="" style="width: 100%;"
                                  class="txt-area"></textarea>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Desired_Credit_Risk_allocation,
                                          'Desired_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Desired_Credit_Risk_allocation,
                                          'Actual_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Desired_Liquidity_allocation'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Desired Credit Risk Allocation</th>
                              <th class="text-right">Desired Mix (%)</th>
                              <th class="text-right">Actual Mix (%)</th>
                              <th class="text-right">% Dev</th>
                              <th>Action Required (Y/N)</th>
                              <th>Rationale</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Desired_Liquidity_allocation">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Desired_Liquidity_allocation"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Desired_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Actual_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Dev'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-center" type="text"
                                    v-model="itemLbl['Action_Required_Y_N']" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Rationale']" /> -->
                                  <textarea v-model="itemLbl['Rationale']" rows="2" placeholder="" style="width: 100%;"
                                  class="txt-area"></textarea>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Desired_Liquidity_allocation,
                                          'Desired_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Desired_Liquidity_allocation,
                                          'Actual_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Desired_Max_Duration_years'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Desired Max Duration (years)</th>
                              <th class="text-right">Desired Years</th>
                              <th class="text-right">Actual Years</th>
                              <th class="text-right">% Dev</th>
                              <th>Action Required (Y/N)</th>
                              <th>Rationale</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Desired_Max_Duration_years">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Desired_Max_Duration_years"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" :value="itemLbl['Desired_Mix_%']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" :value="itemLbl['Actual_Mix_%']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" :value="itemLbl['%_Dev']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-center" type="text"
                                    v-model="itemLbl['Action_Required_Y_N']" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Rationale']" /> -->
                                  <textarea v-model="itemLbl['Rationale']" rows="2" placeholder="" style="width: 100%;"
                                  class="txt-area"></textarea>
                                </td>
                              </tr>
                              <!-- <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Desired_Max_Duration_years,
                                          'Desired_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Desired_Max_Duration_years,
                                          'Actual_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                              </tr> -->
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Maximum_Exposure'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th></th>
                              <th class="text-right">Limit Cap</th>
                              <th class="text-right">Actual %</th>
                              <th class="text-right">% Dev</th>
                              <th>Action Required (Y/N)</th>
                              <th>Rationale</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;" v-if="profileAllocationAnalysisClientData.Maximum_Exposure">
                              <tr v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Maximum_Exposure"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Desired_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Actual_Mix_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Dev'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-center" type="text"
                                    v-model="itemLbl['Action_Required_Y_N']" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Rationale']" /> -->
                                  <textarea v-model="itemLbl['Rationale']" rows="2" placeholder="" style="width: 100%;"
                                  class="txt-area"></textarea>
                                </td>
                              </tr>
                              <!-- <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Maximum_Exposure,
                                          'Desired_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        totalCalculate(profileAllocationAnalysisClientData.Maximum_Exposure,
                                          'Actual_Mix_%') }}
                                    </strong>
                                  </label>
                                </td>
                              </tr> -->
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Limit_Cap_rebalancing_record'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr class="text-center">
                              <th></th>
                              <th class="align-middle">Limit Cap</th>
                              <th class="align-middle">Actual</th>
                              <th class="align-middle">% Dev</th>
                              <th class="align-middle">Action Required (Y/N)</th>
                              <th class="align-middle">Sell/Bought (%)</th>
                              <th class="align-middle">Amount to be bought/sold (INR)</th>
                              <th class="align-middle">Final Allocation (%)</th>
                              <th class="align-middle">Rationale</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Limit_Cap_rebalancing_record">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Limit_Cap_rebalancing_record"
                                :key="itemLblIdx">
                                <td>
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Limit_Cap'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" :value="itemLbl['Actual']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Dev'])" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Action']" /> -->
                                  <textarea v-model="itemLbl['Action']" rows="2" placeholder="" style="width: 100%;"
                                    class="txt-area"></textarea>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Sell_Bought_%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="itemLbl['Amount_to_be_bought_sold_INR']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Final_Allocation_%'])" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs text-center" type="text" v-model="itemLbl['Rationale']" /> -->
                                  <textarea v-model="itemLbl['Rationale']" rows="2" placeholder="" style="width: 100%;"
                                    class="txt-area"></textarea>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Expense_ratio_Cap_rebalancing'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th></th>
                              <th class="text-center">Limit Cap</th>
                              <th class="text-center">Actual</th>
                              <th class="text-center">% Dev</th>
                              <th>Action Required (Y/N)</th>
                              <th>Rationale</th>
                              <th>Amount to be sold (INR)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Expense_ratio_Cap_rebalancing">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Expense_ratio_Cap_rebalancing"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Limit_Cap'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" :value="itemLbl['Actual']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['%_Dev'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs" type="text" v-model="itemLbl['Action_Required_Y_N']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs" type="text" v-model="itemLbl['Rationale']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="itemLbl['Amount_to_be_sold_INR']" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'MF_Portfolio_Summary_Categorywise'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Category</th>
                              <th class="text-center">Amount</th>
                              <th class="text-center">Weight (%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.MF_Portfolio_Summary_Categorywise">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.MF_Portfolio_Summary_Categorywise.record"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.Category }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" :value="itemLbl['Amount']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="itemLbl['Weight (%)']" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        profileAllocationAnalysisClientData.MF_Portfolio_Summary_Categorywise.Total_Amount_INR
                                      }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        profileAllocationAnalysisClientData.MF_Portfolio_Summary_Categorywise['Total_Weight_%']
                                      }}%
                                    </strong>
                                  </label>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'MF_Portfolio_Summary_Main_Categorywise'" style="background-color: white;">
                  <a class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Category</th>
                              <th class="text-center">Amount</th>
                              <th class="text-center">Weight (%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.MF_Portfolio_Summary_Main_Categorywise">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.MF_Portfolio_Summary_Main_Categorywise.record"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.MainCategory }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" :value="itemLbl['Amount']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="itemLbl['Weight (%)']" />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        profileAllocationAnalysisClientData.MF_Portfolio_Summary_Main_Categorywise.Total_Amount_INR
                                      }}
                                    </strong>
                                  </label>
                                </td>
                                <td class="text-right">
                                  <label>
                                    <strong>
                                      {{
                                        profileAllocationAnalysisClientData.MF_Portfolio_Summary_Main_Categorywise['Total_Weight_%']
                                      }}%
                                    </strong>
                                  </label>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Investor_Risk_Profile'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th class="align-middle" style="width: 40%;">Risk-limits</th>
                              <th class="align-middle" style="width: 15%;"
                                v-if="profileAllocationAnalysisClientData.Investor_Risk_Profile_Header">
                                {{
                                  profileAllocationAnalysisClientData.Investor_Risk_Profile_Header
                                }}
                              </th>
                              <th v-else class="align-middle text-center">Moderate</th>
                              <th class="text-center align-middle" style="width: 15%;">Actual</th>
                              <th class="text-center align-middle" style="width: 10%;">Difference</th>
                              <th class="align-middle" style="width: 20%;">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Investor_Risk_Profile">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Investor_Risk_Profile"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Risk_profile%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Actual%'])" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    :value="convertPercent(itemLbl['Difference'])" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Action']" /> -->
                                  <textarea v-model="itemLbl['Action']" rows="2" placeholder="" style="width: 100%;"
                                    class="txt-area"></textarea>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Stock_Portfolio_report'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Stock Portfolio report</th>
                              <th class="text-center" style="width:9%">Limit</th>
                              <th class="text-center" style="width:9%">Actual</th>
                              <th class="text-center" style="width:9%">Difference</th>
                              <th class="text-center">Details</th>
                              <th class="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Stock_Portfolio_report">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Stock_Portfolio_report"
                                :key="itemLblIdx">
                                <td class="align-top">
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td class="align-top">
                                  <input class="new-tbl-cs text-right" type="text" v-model="itemLbl['limit']" />
                                </td>
                                <td class="align-top">
                                  <input class="new-tbl-cs text-right" type="text" v-model="itemLbl['Actual']" />
                                </td>
                                <td class="align-top">
                                  <input class="new-tbl-cs text-right" type="text" v-model="itemLbl['Difference']" />
                                </td>
                                <td class="align-top">
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['details']" /> -->
                                  <textarea v-model="itemLbl['details']" rows="2" placeholder="" style="width: 100%;"
                                    class="txt-area"></textarea>
                                </td>
                                <td class="align-top">
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Action']" /> -->
                                  <textarea v-model="itemLbl['Action']" rows="2" placeholder="" style="width: 100%;"
                                    class="txt-area"></textarea>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Mutual_Fund_Portfolio_report'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th style="width: 30%;">Mutual Fund Portfolio report</th>
                              <th style="width: 10%;" class="text-center">Limit</th>
                              <th style="width: 10%;" class="text-center">Actual</th>
                              <th style="width: 10%;" class="text-center">Difference</th>
                              <th style="width: 20%;" class="text-center">Details</th>
                              <th style="width: 20%;" class="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="profileAllocationAnalysisClientData.Mutual_Fund_Portfolio_report">
                              <tr
                                v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisClientData.Mutual_Fund_Portfolio_report"
                                :key="itemLblIdx">
                                <td class="align-middle">
                                  <label>{{ itemLbl.field_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="itemLbl['limit']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="itemLbl['Actual']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="itemLbl['Difference']" />
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['details']" /> -->
                                  <textarea v-model="itemLbl['details']" rows="2" placeholder="" style="width: 100%;"
                                    class="txt-area"></textarea>
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="itemLbl['Action']" /> -->
                                  <textarea v-model="itemLbl['Action']" rows="2" placeholder="" style="width: 100%;"
                                    class="txt-area w-full"></textarea>
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>

                <th v-if="tab.value === 'profile_allocation_analysis_summery'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Summary:</th>
                              <th class="text-center">INR</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-if="profileAllocationAnalysisSummery.length > 0"
                              v-for="(itemLbl, itemLblIdx) in profileAllocationAnalysisSummeryLblData" :key="itemLblIdx"
                              style="display: contents;">
                              <tr>
                                <td class="align-middle">
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="profileAllocationAnalysisSummery[0][itemLbl.field]" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'new_asset_stock_selection' && curTab === 'With New Cash and Portfolio Changes'"
                  style="background-color: white;"><a class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name
                      }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div style="height: 400px;position: relative;overflow: auto;">
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th class="text-center align-middle"
                                v-for="(lblData, lblIdx) in newAssetStockSelectionLblData" :kay="lblIdx">{{
                                  lblData.lbl }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-if="newAssetStockSelectionTblData.data"
                              v-for="(obj, itemLblIdx) in newAssetStockSelectionTblData.data" :key="itemLblIdx"
                              style="display: contents;">
                              <tr>
                                <td class="align-middle">
                                  <label>{{ obj.name }}</label>
                                </td>
                                <td class="align-middle">
                                  <label>{{ obj.sector_name }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj['INR_auto_filled']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="obj['INR_manually_filled']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj['Price']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="obj['market_capitalization']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj['Number_of_units']" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitNewAssetStockSelectionAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th
                  v-if="tab.value === 'new_asset_Mutual_Funds_selection_table' && curTab === 'With New Cash and Portfolio Changes'"
                  style="background-color: white;">
                  <a class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div style="height: 400px;position: relative;overflow: auto;">
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th class="text-center" v-for="(lblData, lblIdx) in newAssetMFSelectionLblData"
                                :kay="lblIdx">{{
                                  lblData.lbl }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-if="newAssetStockSelectionTblData.data"
                              v-for="(obj, itemLblIdx) in newAssetMFSelectionTblData.data" :key="itemLblIdx"
                              style="display: contents;">
                              <tr>
                                <td class="align-middle">
                                  <label>{{ obj.sch_name }}</label>
                                </td>
                                <td class="align-middle">
                                  <label>{{ obj.Category }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj['INR_auto_filled']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="obj['INR_manually_filled']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj['Price']" />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj['Number_of_units']" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info" @click="submitNewAssetMFSelectionAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Existing_Stocks_to_be_bought_more'" style="background-color: white;">
                  <a class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th v-for="(lblData, lblIdx) in existingStockBoughtMore" :kay="lblIdx">{{
                                lblData.lbl }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-if="profileAllocationAnalysisClientData.Existing_Stocks_to_be_bought_more"
                              style="display: contents;">
                              <tr
                                v-for="(subFieldObj, subItmIdx) in profileAllocationAnalysisClientData.Existing_Stocks_to_be_bought_more.record"
                                :key="subItmIdx">
                                <td v-for="(lblObj, itemLblIdx) in existingStockBoughtMore" :key="itemLblIdx"
                                  :class="{ 'text-right': lblObj.field !== 'field_name' && lblObj.field !== 'Sector', 'align-middle': true }">
                                  <input v-if="lblObj.field === 'More_to_be_bought_INR_manual'"
                                    class="new-tbl-cs text-right" type="text" v-model="subFieldObj[lblObj.field]" />
                                  <label v-else>{{ subFieldObj[lblObj.field] }}</label>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Total
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">
                                  {{
                                    profileAllocationAnalysisClientData.Existing_Stocks_to_be_bought_more.Total_Amount_INR
                                  }}
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitExistingStocksToBeBoughtMore">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Existing_Stocks_to_be_sold'" style="background-color: white;">
                  <a class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th v-for="(lblData, lblIdx) in existingStocksSold" :kay="lblIdx">{{
                                lblData.lbl }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-if="profileAllocationAnalysisClientData.Existing_Stocks_to_be_sold"
                              style="display: contents;">
                              <tr
                                v-for="(subFieldObj, subItmIdx) in profileAllocationAnalysisClientData.Existing_Stocks_to_be_sold.record"
                                :key="subItmIdx">
                                <td v-for="(lblObj, itemLblIdx) in existingStocksSold" :key="itemLblIdx"
                                  :class="[lblObj.field === 'Latest_Value_INR ' || lblObj.field === 'To_be_sold_INR' || lblObj.field === 'To_be_sold_INR_manual' || lblObj.field === 'Price' || lblObj.field === 'Number_of_units' ? 'text-right' : 'align-middle']">
                                  <input v-if="lblObj.field === 'To_be_sold_INR_manual'" class="new-tbl-cs" type="text"
                                    v-model="subFieldObj[lblObj.field]" />
                                  <label v-else>{{ subFieldObj[lblObj.field] }}</label>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Total
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">
                                  {{
                                    profileAllocationAnalysisClientData.Existing_Stocks_to_be_sold.Total_Amount_INR
                                  }}
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info" @click="submitExistingStocksToBeSold">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Existing_MF_Schemes_to_be_bought_more'" style="background-color: white;">
                  <a class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th v-for="(lblData, lblIdx) in existingMFSchemesBoughtMore" :kay="lblIdx">{{
                                lblData.lbl }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-if="profileAllocationAnalysisClientData.Existing_MF_Schemes_to_be_bought_more"
                              style="display: contents;">
                              <tr
                                v-for="(subFieldObj, subItmIdx) in profileAllocationAnalysisClientData.Existing_MF_Schemes_to_be_bought_more.record"
                                :key="subItmIdx">
                                <td v-for="(lblObj, itemLblIdx) in existingMFSchemesBoughtMore" :key="itemLblIdx"
                                  :class="[lblObj.field === 'Latest_Value_INR ' || lblObj.field === 'More_to_be_bought_INR' || lblObj.field === 'More_to_be_bought_INR_manual' || lblObj.field === 'Price' || lblObj.field === 'Number_of_units' ? 'text-right' : 'align-middle']">
                                  <input v-if="lblObj.field === 'More_to_be_bought_INR_manual'"
                                    class="new-tbl-cs text-right" type="text" v-model="subFieldObj[lblObj.field]" />
                                  <label v-else>{{ subFieldObj[lblObj.field] }}</label>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Total
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">
                                  {{
                                    profileAllocationAnalysisClientData.Existing_MF_Schemes_to_be_bought_more.Total_Amount_INR
                                  }}
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitExistingMFSchemesToBeBought">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'Existing_MF_Schemes_to_be_sold'" style="background-color: white;">
                  <a class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th v-for="(lblData, lblIdx) in existingMFSchemesSold" :kay="lblIdx">{{
                                lblData.lbl }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-if="profileAllocationAnalysisClientData.Existing_MF_Schemes_to_be_sold"
                              style="display: contents;">
                              <tr
                                v-for="(subFieldObj, subItmIdx) in profileAllocationAnalysisClientData.Existing_MF_Schemes_to_be_sold.record"
                                :key="subItmIdx">
                                <td v-for="(lblObj, itemLblIdx) in existingMFSchemesSold" :key="itemLblIdx"
                                  :class="[lblObj.field === 'Latest_Value_INR ' || lblObj.field === 'To_be_sold_INR' || lblObj.field === 'To_be_sold_INR_manual' || lblObj.field === 'Price' || lblObj.field === 'Number_of_units' ? 'text-right' : 'align-middle']">
                                  <input v-if="lblObj.field === 'To_be_sold_INR_manual'" class="new-tbl-cs text-right"
                                    type="text" v-model="subFieldObj[lblObj.field]" />
                                  <label v-else>{{ subFieldObj[lblObj.field] }}</label>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Total
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">
                                  {{
                                    profileAllocationAnalysisClientData.Existing_MF_Schemes_to_be_sold.Total_Amount_INR
                                  }}
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitExistingMFSchemesToBeSold">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'individual_stock_investments'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in indivStockInvestmentsLblData" :key="index"
                                :style="[item.field === 'name' ? { 'width': '15%' } : { 'width': 'auto' }]"
                                class="align-middle">
                                {{ item.lbl }}
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody v-if="indivStockInvestmentsTblData.List_of_all_individual_stock_investments">
                            <tr
                              v-for="(key, index) in indivStockInvestmentsTblData.List_of_all_individual_stock_investments"
                              :key="index">
                              <td v-for="(itemLbl, subIdx) in indivStockInvestmentsLblData" :key="subIdx"
                                :class="[itemLbl.field !== 'name_of_stock' && itemLbl.field !== 'sectorname' && itemLbl.field !== 'industry_type' ? 'text-right' : '']"
                                class="align-middle">
                                <label v-if="itemLbl.field === 'name_of_stock' || itemLbl.field === 'sectorname'">{{
                                  key[itemLbl.field] }}</label>
                                <label v-else>{{ key[itemLbl.field] }}</label>
                              </td>
                              <td class="align-middle"><a class="btn btn-sm btn-small btn-danger"
                                  @click="submitIndivStockInvestmentsAPI(index)"><i title="Delete Row"
                                    class="fa fa-trash cwhite"></i></a></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td class="text-right">
                                {{ indivStockInvestmentsTblData.total_latest_value }}
                              </td>
                              <td class="text-right">
                                {{ indivStockInvestmentsTblData.total_latest_value_pr }}%
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-0">
                            <button type="button" class="btn btn-info" @click="submitAssetClassAPI1">Submit</button>
                          </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'individual_mf_investments'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in indivMFInvestmentsLblData" :key="index"
                                :style="[item.field === 'sch_name' ? { 'width': '15%' } : { 'width': 'auto' }]"
                                class="align-middle">
                                {{ item.lbl }}
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody v-if="indivMFInvestmentsTblData.List_of_all_individual_MF_investments">
                            <tr v-for="(key, index) in indivMFInvestmentsTblData.List_of_all_individual_MF_investments"
                              :key="index">
                              <td v-for="(itemLbl, subIdx) in indivMFInvestmentsLblData" :key="subIdx"
                                :class="[itemLbl.field !== 'sch_name' && itemLbl.field !== 'MainCategory' && itemLbl.field !== 'Category' && itemLbl.field !== 'Name_AMC' && itemLbl.field !== 'FundManager' && itemLbl.field !== 'Recommended' ? 'text-right' : 'align-middle']">
                                <label
                                  v-if="itemLbl.field === 'sch_name' || itemLbl.field === 'Name_AMC' || itemLbl.field === 'MainCategory' || itemLbl.field === 'Category' || itemLbl.field === 'FundManager'">{{
                                    key[itemLbl.field] }}</label>
                                <label v-else>{{ key[itemLbl.field] }}</label>
                              </td>
                              <td class="align-middle"><a class="btn btn-sm btn-small btn-danger"
                                  @click="submitIndivMFInvestmentsAPI(index)"><i title="Delete Row"
                                    class="fa fa-trash cwhite"></i></a></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td class="text-right">{{
                                indivMFInvestmentsTblData.total_latest_value }}</td>
                              <td class="text-right">
                                {{ indivMFInvestmentsTblData.total_latest_value_pr }}%
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
              </tr>
            </table>
          </div>
        </form>
      </div>
      <div class="clear-fix"></div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import Datepicker from "vuejs-datepicker";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: { Datepicker },
  mixins: [commonMixins],
  name: "UserProfiling",
  props: ["user"],
  created() {
    console.log('user-profiling >> this.$route.params', this.$route.params);
    this.curTabIndex = this.$route.query.tab;
    console.log("user-profiling >> ::: Route Tab id", this.curTabIndex);

    if (this.curTabIndex == 0) {
      this.curTab = 'Zero New Cash';
    } else if (this.curTabIndex == 1) {
      this.curTab = 'With New Cash';
    } else if (this.curTabIndex == 2) {
      this.curTab = 'With New Cash and Portfolio Changes';
    } else {
      this.curTab = 'Zero New Cash';
      this.curTabIndex = 0;
    }


    this.userId = parseFloat(this.$route.params.id);

    this.selectedStrategyTitleItem = null;

    this.getTabWiseDateAPI();
    this.getProfileAllocationAnalysisClientData();
    //this.getProfileAllocationAnalysisSummeryAPI();
    this.getNewAssetStockSelectionTableAPI();
    this.getNewAssetMFSelectionTableAPI();
    this.getIndivStockInvestmentsAPI();
    this.getIndivMFInvestmentsAPI();
  },
  data() {
    return {
      isIntFirstTime: true,
      curTab: "",
      userId: null,
      tabName: "",
      apiUrl: "frontend/getStockUserDetails",
      retirementFormData: [{ "data": [] }],
      curTabIndex: 0,
      ddate: "",
      strategyMasterData: [],
      selectedStrategyTitleItem: null,
      selectedCategoryItem: null,
      ifIsBlank: false,
      categoryMasterData: [],
      usersStrategyForm: [],
      otherTabs: { summary: true, hubble: true, aaa: true, time_horizon: true, risk_profile: true, income_generation: true, professionals_recommendation: true },
      grableTreeFactorData: {},
      interpretationResults: {},
      firstInvestmentTblData: [],
      /* NEW DATA: START */
      tabsData: [
        { name: "Profile Analysis Client", value: "profile_allocation_analysis_client", show: false },
        { name: "HUBBLE-GRABLE THREE-FACTOR MODEL OF INVESTOR RISK PROFILING", value: "hubble_grable_three_factor_risk_profiling", show: false },
        { name: "Desired Asset Allocation", value: "desired_asset_allocation", show: false },
        { name: "Desired Alternatives", value: "desired_alternatives", show: false },
        { name: "Current Table", value: "current_table", show: false },
        { name: "Desired vs Actual Asset Allocation", value: "desired_vs_actual_asset_allocation", show: false },
        { name: "Desired vs Actual Alternatives Allocation", value: "desired_vs_actual_alternatives_allocation", show: false },
        { name: "Desired Market cap Allocation", value: "Desired_Market_cap_allocation", show: false },
        { name: "Desired Credit Risk Allocation", value: "Desired_Credit_Risk_allocation", show: false },
        { name: "Desired Liquidity Allocation", value: "Desired_Liquidity_allocation", show: false },
        { name: "Desired Max Duration Years", value: "Desired_Max_Duration_years", show: false },
        { name: "Maximum Exposure", value: "Maximum_Exposure", show: false },
        { name: "Limit Cap Rebalancing Record", value: "Limit_Cap_rebalancing_record", show: false },
        { name: "Expense Ratio Cap Rebalancing", value: "Expense_ratio_Cap_rebalancing", show: false },
        { name: "MF Portfolio Summary (current) - Categorywise", value: "MF_Portfolio_Summary_Categorywise", show: false },
        { name: "MF Portfolio Summary (current) - Main Categorywise", value: "MF_Portfolio_Summary_Main_Categorywise", show: false },
        { name: "Investor Risk Profile", value: "Investor_Risk_Profile", show: false },
        { name: "Stock Portfolio Report", value: "Stock_Portfolio_report", show: false },
        { name: "Mutual Fund Portfolio Report", value: "Mutual_Fund_Portfolio_report", show: false },
        { name: "Profile Allocation Analysis Summary", value: "profile_allocation_analysis_summery", show: false },
        { name: "New Asset Stock Selection", value: "new_asset_stock_selection", show: false },
        { name: "New Asset Mutual Funds Selection", value: "new_asset_Mutual_Funds_selection_table", show: false },

        { name: "Existing Stocks to be bought more", value: "Existing_Stocks_to_be_bought_more", show: false },
        { name: "Existing Stocks to be sold", value: "Existing_Stocks_to_be_sold", show: false },
        { name: "Existing MF Schemes to be bought more", value: "Existing_MF_Schemes_to_be_bought_more", show: false },
        { name: "Existing MF Schemes to be sold", value: "Existing_MF_Schemes_to_be_sold", show: false },

        { name: "List of all individual stock investments (get data from S1 S)", value: "individual_stock_investments", show: false },
        { name: "List of all individual MF investments", value: "individual_mf_investments", show: false }
      ],
      profileAllocationAnalysisClientLblData1: [
        { lbl: "Risk Need", field: "portfolio_allocation_fields_Summary", sub_field: "risk_need" },
        { lbl: "Risk-taking ability", field: "portfolio_allocation_fields_Summary", sub_field: "risk_taking_ability" },
        { lbl: "Behavioral loss tolerance", field: "portfolio_allocation_fields_Summary", sub_field: "behavioral_loss_tolerance" },
        { lbl: "Risk Tolerance / Investor Profile", field: "portfolio_allocation_fields_Summary", sub_field: "risk_tolerance_investor_profile" },
        { lbl: "Financial consequence", field: "portfolio_allocation_fields_Summary", sub_field: "financial_consequence" },
        { lbl: "Investing experience", field: "portfolio_allocation_fields_Summary", sub_field: "investing_experience" },
        { lbl: "Investing experience Brief", field: "portfolio_allocation_fields_Summary", sub_field: "investing_experience_brief" },
      ],
      profileAllocationAnalysisClientLblData: [
        { lbl: "Risk Need", field: "portfolio_allocation_fields_Summary", sub_field: "risk_need" },
        { lbl: "Risk-taking ability", field: "portfolio_allocation_fields_Summary", sub_field: "risk_taking_ability" },
        { lbl: "Behavioral loss tolerance", field: "portfolio_allocation_fields_Summary", sub_field: "behavioral_loss_tolerance" },
        { lbl: "Risk Tolerance / Investor Profile", field: "portfolio_allocation_fields_Summary", sub_field: "risk_tolerance_investor_profile" },
        { lbl: "Financial consequence", field: "portfolio_allocation_fields_Summary", sub_field: "financial_consequence" },
        { lbl: "Investing experience", field: "portfolio_allocation_fields_Summary", sub_field: "investing_experience" },
        { lbl: "Investing experience Brief", field: "portfolio_allocation_fields_Summary", sub_field: "investing_experience_brief" },
      ],
      profileAllocationAnalysisClientData: {},
      hubbleGrableThreeFactorLblData: [
        { lbl: "Risk Need", field: "portfolio_allocation_fields_Summary", sub_field: "risk_need" },
        { lbl: "Risk-Taking Ability", field: "portfolio_allocation_fields_Summary", sub_field: "risk_taking_ability" },
        { lbl: "Behavioral Loss Tolerance", field: "portfolio_allocation_fields_Summary", sub_field: "behavioral_loss_tolerance" },
        { lbl: "Green/Yellow/Red Light", field: "portfolio_allocation_fields_Summary", sub_field: "green_yellow_red_light" },
        { lbl: "Recommendation", field: "portfolio_allocation_fields_Summary", sub_field: "recommendation" },
        { lbl: "Strategy", field: "portfolio_allocation_fields_Summary", sub_field: "strategy" }
      ],
      currentTableLblData: [
        { lbl: "Total Portfolio Value", field: "current_table", sub_field: "total_portfolio_value_INR" },
        { lbl: "Total Stock Value", field: "current_table", sub_field: "stock_portfolio_value" },
        { lbl: "Total MF Value", field: "current_table", sub_field: "mutual_fund_portfolio_value" },
        { lbl: "Investor profile", field: "current_table", sub_field: "investor_profile" },
        { lbl: "Investment horizon (years)", field: "current_table", sub_field: "investment_horizon_years_weighted" },
        { lbl: "Taxation status", field: "current_table", sub_field: "taxation_status" },
        { lbl: "New Cash Available", field: "current_table", sub_field: "new_cash_available" }
      ],
      profileAllocationAnalysisSummery: [],
      profileAllocationAnalysisSummeryLblData: [
        { lbl: "Total Portfolio Value", field: "Total_Portfolio_Value", sub_field: "" },
        { lbl: "Total Rebalancing Required (Stocks for Sale)", field: "Total_Rebalancing_Required_Stocks_for_Sale", sub_field: "" },
        { lbl: "Total Rebalancing Required (Stocks for Additional Purchases)", field: "Total_Rebalancing_Required_Stocks_for_Additional_Purchases", sub_field: "" },
        { lbl: "Total Rebalancing Required (MF Schemes for Sale)", field: "Total_Rebalancing_Required_MF_Schemes_for_Sale", sub_field: "" },
        { lbl: "Total Rebalancing Required (MF Schemes for Additional Purchases)", field: "Total_Rebalancing_Required_MF_Schemes_for_Additional_Purchases", sub_field: "" },
        { lbl: "New Cash available", field: "New_Cash_available", sub_field: "" },
        { lbl: "Total cash available", field: "Total_cash_available", sub_field: "" }
      ],
      newAssetStockSelectionTblData: {},
      newAssetStockSelectionLblData: [
        { lbl: "Stock name", field: "name" },
        { lbl: "Sector Name", field: "sector_name" },
        { lbl: "INR (auto filled)", field: "INR_auto_filled" },
        { lbl: "INR (manually filled)", field: "INR_manually_filled" },
        { lbl: "Price", field: "Price" },
        { lbl: "Market Capitalization", field: "market_capitalization" },
        { lbl: "Number of units", field: "Number_of_units" }
      ],
      newAssetMFSelectionTblData: {},
      newAssetMFSelectionLblData: [
        { lbl: "Scheme name", field: "sch_name" },
        { lbl: "Category", field: "Category" },
        { lbl: "INR (auto filled)", field: "INR_auto_filled" },
        { lbl: "INR (manually filled)", field: "INR_manually_filled" },
        { lbl: "Price", field: "Price" },
        /* { lbl: "Market Capitalization", field: "market_capitalization" }, */
        { lbl: "Number of units", field: "Number_of_units" }
      ],
      //NEW 4 Tables
      existingStockBoughtMore: [
        { lbl: "Stock name", field: "field_name" },
        { lbl: "Sector", field: "Sector" },
        { lbl: "Mkt Cap", field: "Mkt_Cap" },
        { lbl: "Latest Value INR", field: "Latest_Value_INR " },
        { lbl: "More to be bought INR", field: "More_to_be_bought_INR" },
        { lbl: "More to be bought INR Manual", field: "More_to_be_bought_INR_manual" },
        { lbl: "Price", field: "Price" },
        { lbl: "Number of units", field: "Number_of_units" }
      ],
      existingStocksSold: [
        { lbl: "Stock name", field: "field_name" },
        { lbl: "Sector", field: "Sector" },
        { lbl: "Mkt Cap", field: "Mkt_Cap" },
        { lbl: "Latest Value INR", field: "Latest_Value_INR " },
        { lbl: "To be sold INR", field: "To_be_sold_INR" },
        { lbl: "To be sold INR Manual", field: "To_be_sold_INR_manual" },
        { lbl: "Price", field: "Price" },
        { lbl: "Number of units", field: "Number_of_units" }
      ],
      existingMFSchemesBoughtMore: [
        { lbl: "MF Scheme name", field: "field_name" },
        { lbl: "Main Category", field: "Main_Category" },
        { lbl: "Category", field: "Category" },
        { lbl: "AMC Name ", field: "Name_AMC" },
        { lbl: "Fund Manager", field: "Fund_Manager" },
        { lbl: "Latest Value INR", field: "Latest_Value_INR " },
        { lbl: "More to be bought INR", field: "More_to_be_bought_INR" },
        { lbl: "More to be bought INR Manual", field: "More_to_be_bought_INR_manual" },
        { lbl: "Price", field: "Price" },
        { lbl: "Number of units", field: "Number_of_units" }
      ],
      existingMFSchemesSold: [
        { lbl: "MF Scheme name", field: "field_name" },
        { lbl: "Main Category", field: "Main_Category" },
        { lbl: "Category", field: "Category" },
        { lbl: "AMC Name ", field: "Name_AMC" },
        { lbl: "Fund Manager", field: "Fund_Manager" },
        { lbl: "Latest Value INR", field: "Latest_Value_INR " },
        { lbl: "To be sold INR", field: "To_be_sold_INR" },
        { lbl: "To be sold INR Manual", field: "To_be_sold_INR_manual" },
        { lbl: "Price", field: "Price" },
        { lbl: "Number of units", field: "Number_of_units" }
      ],
      dateFilterTabWiseData: [],

      indivStockInvestmentsLblData: [
        { lbl: "Name", field: "name_of_stock" },
        { lbl: "Sector", field: "sectorname" },
        { lbl: "MktCap (INR Cr)", field: "marketCapitalization_latest" },
        { lbl: "Mkt Cap type (SEBI Large/Mid/Small)", field: "industry_type" },
        { lbl: "Latest Value (INR)", field: "latest_value" },
        { lbl: "LV/Total (%)", field: "latest_value_per_all_values_of_company%" },//lv_by_total_%
        { lbl: "P11", field: "business_score" },
        { lbl: "Qtrly", field: "p11_quarterly_trends_score" },
        { lbl: "Q1ab", field: "valuation_q1_a_S_or_q1_b_S" },
        { lbl: "z1", field: "z1_score" },
        { lbl: "Beta", field: "latest_beta" },
        { lbl: "Cash flow", field: "latest_free_cash_flow" },
        { lbl: "Actual EPS G % CAGR 5Yrs", field: "actual_eps_growth_cagr_5_years" },
        { lbl: "Actual Latest RoE", field: "actual_latest_roe" },
        { lbl: "Liquidity", field: "less_liquid_stock" },
      ],
      indivStockInvestmentsTblData: [],
      indivMFInvestmentsLblData: [
        { lbl: "Name", field: "sch_name" },
        { lbl: "Main Category", field: "MainCategory" },
        { lbl: "Category", field: "Category" },
        { lbl: "AMC", field: "Name_AMC" },
        { lbl: "Fund Mgr", field: "FundManager" },
        { lbl: "Latest Value (INR)", field: "latest_value" },
        { lbl: "LV/Total (%)", field: "latest_value_per_all_values_of_company%" },//lv_by_total_%
        { lbl: "Recommended (Y/N)", field: "Recommended" },
        { lbl: "Overall Rating", field: "overall_scheme_rating" },
        { lbl: "Business Rating", field: "overall_business_rating" },
        { lbl: "Valuation Rating", field: "overall_valuation_rating" },
        { lbl: "Quarterly Rating", field: "overall_quarterly_rating" },
        { lbl: "Equity Rating", field: "overall_equity_rating" },
        { lbl: "Debt/Others Rating", field: "overall_debt_others_rating" },
        { lbl: "Large Cap holding%", field: "Large_Cap_holding%" },
        { lbl: "AAA holding %", field: "AAA_holding%" },
        { lbl: "Expense ratio%", field: "Expense_ratio%" },
        { lbl: "Duration (Yrs)", field: "Duration_Yrs" },
        { lbl: "Mean 1Y", field: "Mean_1Y" },
        { lbl: "Std Dev 1Yr", field: "Std_Dev_1Yr" },
        { lbl: "RR 1Yr (NAV > BSE 500)", field: "RR_1Yr_NAV_get_BSE_500" },
        { lbl: "RR 1Yr (NAV > BSE 500 Positive)", field: "RR_1Yr_NAV_BSE_500_Positive" },
        { lbl: "RR 1Yr (NAV < BSE 500 Negative)", field: "RR_1Yr_NAV_BSE_500_Negative" }
      ],
      indivMFInvestmentsTblData: [],
      //NEW 4 Tables
      /* NEW DATA: END */

    };
  },
  methods: {
    downloadXlsFile() {
      let self = this;
      console.log('download XLS', self.curTab);
      let paramData = { "client_id": self.userId, "Analysis_Sheet": self.curTab, "insert_date": self.ddate == '' || self.ddate == null ? "" : self.ddate };
      console.log('paramData: ', paramData);
      //return;
      http.post("/frontend/download_sheet_profile_allocation_analysis/get", paramData, (error, response) => {
        if (response.responseType === 'success') {
          console.log('res data', response);
          window.open(response.download_link);
        }
      });
    },
    /*--------------------------*/
    /* Update Cron Data : START */
    /*--------------------------*/
    updateCronData() {
      let self = this;
      let updateCronURL = "";
      if (self.curTab == 'Zero New Cash') {
        updateCronURL = '/frontend/user_porofile_allocation_report_table/update';
      } else if (self.curTab == 'With New Cash') {
        updateCronURL = '/frontend/user_porofile_allocation_report_table_with_new_cash_update/update';
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        updateCronURL = '/frontend/user_porofile_allocation_report_table_with_new_cash_and_portfolio_update/update';
      }

      let paramData = { "client_id": self.userId }
      console.log('updateCronURL:', updateCronURL, 'paramData: ', paramData)
      //return;
      http.post(updateCronURL, paramData, (error, response) => {
        console.log('updateCronData : response:', response);
        if (response.responseType === 'success') {
          self.$toastr.success(response.msg, "", {});
        }
      });
    },
    /*------------------------*/
    /* Update Cron Data : END */
    /*------------------------*/
    reset() {

    },
    individualStockInstPerCalc(data) {
      let calc = 0;
      data.map((item) => {
        calc += parseFloat(item['lv_by_total_%']) * 100;
      });
      return calc;
    },
    submitNewAssetStockSelectionAPI() {
      let self = this;

      //console.log(">>> TAB::: ", self.curTab);
      let collectionName = "";
      if (self.curTab == 'Zero New Cash') {
        collectionName = 'without_new_cash';
      } else if (self.curTab == 'With New Cash') {
        collectionName = 'with_new_cash';
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        collectionName = 'with_new_cash_portfolio';
      }
      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "collection_name": collectionName,
        "data": self.newAssetStockSelectionTblData.data
      }

      console.log('paramData:', paramData);
      //return;
      http.post("/frontend/new_asset_stock_selection_table/update?user_update=1", paramData, (error, response) => {
        console.log('submitNewAssetStockSelectionAPI', response);
        if (response.responseType === 'success') {
          self.$toastr.success("Update Success", "", {});
        }
      });
    },
    submitNewAssetMFSelectionAPI() {
      let self = this;
      let paramData = {};
      paramData = {
        "client_id": self.userId,
        'data': self.newAssetMFSelectionTblData.data
      }
      console.log('paramData:', paramData);
      //return;
      http.post("/frontend/new_asset_Mutual_Funds_selection_table/update?user_update=1", paramData, (error, response) => {
        console.log('submitNewAssetMFSelectionAPI', response);
        if (response.responseType === 'success') {
          self.$toastr.success("Update Success", "", {});
        }
      });
    },
    submitExistingStocksToBeBoughtMore() {
      let self = this;
      //console.log('self.newAssetMFSelectionTblData >>> ', self.profileAllocationAnalysisClientData.Existing_Stocks_to_be_bought_more);
      let collectionName = "";
      if (self.curTab == 'Zero New Cash') {
        collectionName = 'without_new_cash';
      } else if (self.curTab == 'With New Cash') {
        collectionName = 'with_new_cash';
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        collectionName = 'with_new_cash_portfolio';
      }

      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "collection_name": collectionName,
        "Existing_Stocks_to_be_bought_more": self.profileAllocationAnalysisClientData.Existing_Stocks_to_be_bought_more
      }
      console.log('/frontend/Existing_Stocks_to_be_bought_more_user_update/post');
      console.log('paramData:', paramData);
      //return;
      http.post("/frontend/Existing_Stocks_to_be_bought_more_user_update/post", paramData, (error, response) => {
        console.log('submitExistingStocksToBeBoughtMore: ', response);
        if (response.status === 'success') {
          self.$toastr.success("Update Success", "", {});
          self.getProfileAllocationAnalysisClientData();
        }
      });
    },
    submitExistingStocksToBeSold() {
      let self = this;
      let collectionName = "";
      if (self.curTab == 'Zero New Cash') {
        collectionName = 'without_new_cash';
      } else if (self.curTab == 'With New Cash') {
        collectionName = 'with_new_cash';
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        collectionName = 'with_new_cash_portfolio';
      }

      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "collection_name": collectionName,
        'Existing_Stocks_to_be_sold': self.profileAllocationAnalysisClientData.Existing_Stocks_to_be_sold
      }
      console.log('/frontend/Existing_Stocks_to_be_sold_user_update/post');
      console.log('paramData:', paramData);
      //return;
      http.post("/frontend/Existing_Stocks_to_be_sold_user_update/post", paramData, (error, response) => {
        console.log('submitExistingStocksToBeSold:', response);
        if (response.status === 'success') {
          self.$toastr.success("Update Success", "", {});
          self.getProfileAllocationAnalysisClientData();
        }
      });
    },
    submitExistingMFSchemesToBeBought() {
      let self = this;
      let collectionName = "";
      if (self.curTab == 'Zero New Cash') {
        collectionName = 'without_new_cash';
      } else if (self.curTab == 'With New Cash') {
        collectionName = 'with_new_cash';
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        collectionName = 'with_new_cash_portfolio';
      }
      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "collection_name": collectionName,
        'Existing_MF_Schemes_to_be_bought_more': self.profileAllocationAnalysisClientData.Existing_MF_Schemes_to_be_bought_more
      }
      console.log('/frontend/Existing_MF_Schemes_to_be_bought_more_user_update/post');
      console.log('paramData:', paramData);
      //return;
      http.post("/frontend/Existing_MF_Schemes_to_be_bought_more_user_update/post", paramData, (error, response) => {
        console.log('submitExistingMFSchemesToBeBought:', response);
        if (response.status === 'success') {
          self.$toastr.success("Update Success", "", {});
          self.getProfileAllocationAnalysisClientData();
        }
      });
    },
    submitExistingMFSchemesToBeSold() {
      let self = this;
      let collectionName = "";
      if (self.curTab == 'Zero New Cash') {
        collectionName = 'without_new_cash';
      } else if (self.curTab == 'With New Cash') {
        collectionName = 'with_new_cash';
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        collectionName = 'with_new_cash_portfolio';
      }
      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "collection_name": collectionName,
        'Existing_MF_Schemes_to_be_sold': self.profileAllocationAnalysisClientData.Existing_MF_Schemes_to_be_sold
      }
      console.log('/frontend/Existing_MF_Schemes_to_be_sold_user_update/post');
      console.log('paramData:', paramData);
      //return;
      http.post("/frontend/Existing_MF_Schemes_to_be_sold_user_update/post", paramData, (error, response) => {
        console.log('submitExistingMFSchemesToBeSold:', response);
        if (response.status === 'success') {
          self.$toastr.success("Update Success", "", {});
          self.getProfileAllocationAnalysisClientData();
        }
      });
    },
    desireAssetAllocationTotal(data) {
      let total = 0;
      data.map((item) => {
        total += parseFloat(item['%_Mix']);
      });
      return total;
    },
    updateUserPortfolioAllocation() {
      let self = this;
      self.$router.push({
        name: "user-portfolio-allocation",
        params: { id: self.userId },
        query: { tab: self.curTabIndex }
      });
    },
    convertPercent(data) {
      return data + "%";
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log('Tab:::', tabIndex, 'newTab:', newTab.title, 'oldTab:', oldTab.title);

      let self = this;

      self.curTabIndex = tabIndex;


      if (newTab.title !== oldTab.title) {
        if (self.isIntFirstTime === false) {
          self.$router.push({
            name: "user-portfolio-analysis",
            params: { id: self.userId },
            query: { tab: self.curTabIndex }
          });
        }
      } else {
        self.isIntFirstTime = false;
        return;
      }

      if (newTab.title === 'Zero New Cash') {
        console.log('Zero New Cash');
        this.curTab = 'Zero New Cash';
        this.ddate = null;
        this.getTabWiseDateAPI();
        this.getProfileAllocationAnalysisClientData();
        //this.getProfileAllocationAnalysisSummeryAPI();
        this.getNewAssetStockSelectionTableAPI();
        this.getNewAssetMFSelectionTableAPI();
        this.getIndivStockInvestmentsAPI();
        this.getIndivMFInvestmentsAPI();
      } else if (newTab.title === 'With New Cash') {
        this.curTab = 'With New Cash';
        this.ddate = null;
        this.getTabWiseDateAPI();
        this.getProfileAllocationAnalysisClientData();
        //this.getProfileAllocationAnalysisSummeryAPI();
        this.getNewAssetStockSelectionTableAPI();
        this.getNewAssetMFSelectionTableAPI();
        this.getIndivStockInvestmentsAPI();
        this.getIndivMFInvestmentsAPI();
      } else if (newTab.title === 'With New Cash and Portfolio Changes') {
        this.curTab = 'With New Cash and Portfolio Changes';
        this.ddate = null;
        this.getTabWiseDateAPI();
        this.getProfileAllocationAnalysisClientData();
        //this.getProfileAllocationAnalysisSummeryAPI();
        this.getNewAssetStockSelectionTableAPI();
        this.getNewAssetMFSelectionTableAPI();
        this.getIndivStockInvestmentsAPI();
        this.getIndivMFInvestmentsAPI();
      }
      self.isIntFirstTime = false;
    },
    //totalCalculate("",'Actual_Mix_%', false, true)
    totalCalculate(data, key, tf = false, showPercentSign = true) {
      const resultTotal = data.reduce((acc, curr) => {
        //console.log('TOTAL: ', acc, parseFloat(curr[key]))
        /* if (tf) {
          return acc + parseFloat(curr[key]) * 100;
        } else {
          return acc + parseFloat(curr[key]);
        } */
        return acc + parseFloat(String(curr[key]));
      }, 0);
      //console.log('TOTAL => ', resultTotal)
      let percentSign = showPercentSign ? '%' : '';
      return tf ? (resultTotal * 100).toFixed(2) : (resultTotal).toFixed(2) + percentSign;
    },
    formatDate(date) {
      console.log('formatDate', this.getDate(date));
      return this.getDate(date);
    },
    selectDate(date, pIdx, field) {
      //console.log('selectDate', this.getDate(date));
      this.firstInvestmentTblData[0].data[pIdx].date_of_first_investment = String(this.getDate(date));
      console.log('key', String(field));
      //console.log('pData', pData);
      console.log('firstInvestmentTblData[0].data >>> ', this.firstInvestmentTblData[0].data[pIdx].date_of_first_investment)
      /* const strKey = String(key)
      console.log('with pData', pData[strKey]);
      pData.date_of_first_investment = this.getDate(date); */
      //return this.getDate(date);
    },
    otherTabsShow(key) {
      //this.otherTabs[key] = !this.otherTabs[key];
    },
    answerFun(evt, index, cIdx) {
      //console.log('answer:', typeof (evt));
      //console.log('answer:', evt);
      if (evt != null) {
        if (typeof (evt) == 'object') {
          //console.log(evt.value);
          //ans = evt.value;
          this.usersStrategyForm.data[index].data[cIdx].answer = evt.value ? evt.value : "";
        }
      } else {
        this.usersStrategyForm.data[index].data[cIdx].answer = "";
      }
    },
    showDetails(tabs) {
      tabs.show = !tabs.show;
      //tabs
      //this.usersStrategyForm.data[idx].show = !this.usersStrategyForm.data[idx].show;
      //console.log('this.usersStrategyForm', this.usersStrategyForm.data);
    },
    /*-------------------------------------*/
    /* Portfolio Allocation Reference: START */
    /*-------------------------------------*/
    getProfileAllocationAnalysisClientData(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = { 'Analysis_Sheet': self.curTab, 'insert_date': self.ddate };
      } else {
        paramData = {
          "client_id": self.userId,
          'Analysis_Sheet': self.curTab,
          'insert_date': self.ddate
        }
      }

      http.post("/frontend/profile_allocation_analysis_client/get", paramData, (error, response) => {
        if (response.status === 'success') {

          console.log('res data', response.data);
          if (response.data.length > 0) {
            self.profileAllocationAnalysisClientData = response.data[0];
            //This code for 'Profile Allocation Analysis Summary' Table show
            if (response.data) {
              self.profileAllocationAnalysisSummery = [response.data[0].profile_allocation_analysis_summery];
              if (self.profileAllocationAnalysisSummery[0] == undefined) {
                self.profileAllocationAnalysisSummery = [];
              }
            }
          } else {
            self.profileAllocationAnalysisClientData = [];
            self.profileAllocationAnalysisSummery = [];
          }
          /* if (response.data.length === 0) {
            self.getProfileAllocationAnalysisClientData(true);
          } else {
            self.profileAllocationAnalysisClientData = response.data;
          } */
        }
      });
    },
    /*-------------------------------------*/
    /* Portfolio Allocation Reference: END */
    /*-------------------------------------*/

    /*---------------------------------------------*/
    /* Profile Allocation Analysis Summary : START */
    /*---------------------------------------------*/
    /* getProfileAllocationAnalysisSummeryAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }
      
      http.post("/frontend/profile_allocation_analysis_summery/get", paramData, (error, response) => {
        console.log('response', response);
        if (response != null) {
          if (response.status === 'success') {
            if (response.data == null) {
              self.profileAllocationAnalysisSummery = [];
              return;
            }
            if (response.data.length === 0) {
              if (!flg) {
                self.getProfileAllocationAnalysisSummeryAPI(true);
              }
            } else {
              self.profileAllocationAnalysisSummery = response.data == null ? [] : response.data;
            }
          }
        }
      });
    }, */
    /*-------------------------------------------*/
    /* Profile Allocation Analysis Summary : END */
    /*-------------------------------------------*/

    /*-----------------------------------------*/
    /* New Asset Stock Selection Table : START */
    /*-----------------------------------------*/
    getNewAssetStockSelectionTableAPI(flg = false) {
      let self = this;
      let paramData = { "client_id": self.userId };
      /*if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      } */

      http.post("/frontend/new_asset_stock_selection_table/get", paramData, (error, response) => {
        if (response.responseType === 'success') {
          if (response.data == null) {
            self.newAssetStockSelectionTblData.data = [];
            return;
          }
          self.newAssetStockSelectionTblData = response.data;
          /* if (response.data.length === 0) {
            self.getNewAssetStockSelectionTableAPI(true);
          } else {
            self.newAssetStockSelectionTblData = response.data;
          } */
        }
      });
    },
    /*---------------------------------------*/
    /* New Asset Stock Selection Table : END */
    /*---------------------------------------*/


    /*--------------------------------------*/
    /* New Asset MF Selection Table : START */
    /*--------------------------------------*/
    getNewAssetMFSelectionTableAPI(flg = false) {
      let self = this;
      let paramData = { "client_id": self.userId };

      http.post("/frontend/new_asset_Mutual_Funds_selection_table/get", paramData, (error, response) => {
        if (response.data == null) {
          self.newAssetMFSelectionTblData.data = [];
          return;
        }
        if (response.responseType === 'success') {
          self.newAssetMFSelectionTblData = response.data;
        }
      });
    },
    /*------------------------------------*/
    /* New Asset MF Selection Table : END */
    /*------------------------------------*/

    /*--------------------------------------*/
    /* New Asset MF Selection Table : START */
    /*--------------------------------------*/
    getSelDate(e) {
      console.log("Selected date", e);
      this.ddate = e;
      if (this.ddate != null) {
        //this.fetchDateWiseReturnData();
      } else {
        //this.dateWiseReturnData = {};
      }
      this.getProfileAllocationAnalysisClientData();
    },
    getTabWiseDateAPI() {
      let self = this;
      let paramData = '';
      console.log(">>> TAB::: ", self.curTab);
      if (self.curTab == 'Zero New Cash') {
        paramData = 'without_new_cash';
      } else if (self.curTab == 'With New Cash') {
        paramData = 'with_new_cash';
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        paramData = 'with_new_cash_portfolio';
      }

      http.get(`/mutual-funds/filter-date?collection_name=${paramData}`, {}, (error, response) => {
        if (response.responseType == 'success') {
          self.dateFilterTabWiseData = response.date;
          return;
        }
      });
    },
    /*------------------------------------*/
    /* New Asset MF Selection Table : END */
    /*------------------------------------*/

    /*-------------------------------------*/
    /* Individual Stock Investment : START */
    /*-------------------------------------*/
    getIndivStockInvestmentsAPI() {
      let self = this;
      let paramData = {
        "client_id": self.userId
      }
      let apiURL = "";
      if (self.curTab == 'Zero New Cash') {
        apiURL = "/frontend/list_of_all_individual_stock_investments/get";
      } else if (self.curTab == 'With New Cash' || self.curTab == 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/profile_allocation_list_of_all_individual_stock_investments_with_s1s/get";
        if (self.curTab == 'With New Cash') {
          paramData.collection_name = 'with_new_cash';
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          paramData.collection_name = 'with_new_cash_portfolio';
        }
      }
      console.log('Stock apiURL:', apiURL, paramData);
      //return;
      http.post(apiURL, paramData, (error, response) => {
        if (response != null) {
          if (response.status === 'success') {
            console.log('getAssetClassAPI >> ', response.data);
            self.indivStockInvestmentsTblData = response.data;
            /* if (response.data.length === 0) {
              self.getIndivStockInvestmentsAPI(true);
            } else {
              self.indivStockInvestmentsTblData = response.data;
            } */
          }
        }
      });
    },
    submitIndivStockInvestmentsAPI(idx) {
      let self = this;

      if (confirm("Are you sure you want to delete this item?") == true) {
        self.indivStockInvestmentsTblData.List_of_all_individual_stock_investments.splice(idx, 1);
        //self.submitCalculationLimitAPI();
      } else {
        return;
      }

      let paramData = self.indivStockInvestmentsTblData;
      delete paramData.total_latest_value;
      delete paramData.total_latest_value_pr;

      let apiURL = "";
      if (self.curTab == 'Zero New Cash') {
        //apiURL = "/frontend/list_of_all_individual_stock_investments/update";
        apiURL = "/frontend/profile_allocation_list_of_all_individual_stock_investments/update";
      } else if (self.curTab == 'With New Cash' || self.curTab == 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/profile_allocation_list_of_all_individual_stock_investments_with_s1s/update";
        if (self.curTab == 'With New Cash') {
          paramData.collection_name = 'with_new_cash';
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          paramData.collection_name = 'with_new_cash_portfolio';
        }
      }
      console.log('## Submit apiURL:', apiURL);
      console.log('## paramData', paramData);
      //return;
      http.post(apiURL, paramData, (error, response) => {

        console.log('#### submitIndivStockInvestmentsAPI >> ', response.status);
        if (response.status === 'success') {
          self.$toastr.success("Update Success...!", "", {});
          self.getIndivStockInvestmentsAPI();
        }
      });
    },
    /*-----------------------------------*/
    /* Individual Stock Investment : END */
    /*-----------------------------------*/

    /*----------------------------------*/
    /* Individual MF Investment : START */
    /*----------------------------------*/
    getIndivMFInvestmentsAPI() {
      let self = this;
      let paramData = {
        "client_id": self.userId
      }

      let apiURL = "";
      if (self.curTab == 'Zero New Cash') {
        apiURL = "/frontend/list_of_all_individual_MF_investments/get";
      } else if (self.curTab == 'With New Cash' || self.curTab == 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/profile_allocation_list_of_all_individual_MF_investments_with_recommended/get";
        if (self.curTab == 'With New Cash') {
          paramData.collection_name = 'with_new_cash';
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          paramData.collection_name = 'with_new_cash_portfolio';
        }
      }

      console.log('getIndivMFInvestmentsAPI apiURL:', apiURL);

      http.post(apiURL, paramData, (error, response) => {
        console.log('response >>>', response);
        if (response.status === 'success') {
          console.log('getIndivMFInvestmentsAPI >> ', response.data);
          self.indivMFInvestmentsTblData = response.data;
        }
      });
    },
    submitIndivMFInvestmentsAPI(idx) {
      let self = this;

      if (confirm("Are you sure you want to delete this item?") == true) {
        self.indivMFInvestmentsTblData.List_of_all_individual_MF_investments.splice(idx, 1);
      } else {
        return;
      }

      let paramData = self.indivMFInvestmentsTblData;
      delete paramData.total_latest_value;
      delete paramData.total_latest_value_pr;

      let apiURL = "";
      if (self.curTab == 'Zero New Cash') {
        apiURL = "/frontend/list_of_all_individual_MF_investments/update";
        paramData.collection_name = 'without_new_cash';
      } else if (self.curTab == 'With New Cash' || self.curTab == 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/profile_allocation_list_of_all_individual_MF_investments_with_recommended/update";
        if (self.curTab == 'With New Cash') {
          paramData.collection_name = 'with_new_cash';
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          paramData.collection_name = 'with_new_cash_portfolio';
        }
      }
      console.log('@@ Submit apiURL:', apiURL);
      console.log('@@ paramData', paramData);
      //return;
      http.post(apiURL, paramData, (error, response) => {
        console.log('#### submitIndivMFInvestmentsAPI >> ', response.status);
        if (response.status === 'success') {
          self.$toastr.success("Update Success...!", "", {});
          self.getIndivMFInvestmentsAPI();
        }
      });
    },
    /*--------------------------------*/
    /* Individual MF Investment : END */
    /*--------------------------------*/

  }
};
</script>
<style>
.table {
  font-size: 0.925em;
}

/* .vdp-datepicker input{
  font-size: small !important;
  background-color: white !important;
} */

.table td {
  padding: 4px 10px 4px 10px !important;
}

.table-xirr {
  width: auto;
}

.txt-area {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.form-cs-n {
  border: 1px solid #c4c2c2;
  padding: 13px;
  /* padding-bottom: 0; */
  border-radius: 7px;
  background-color: #f5faff;
}

.date-pik {
  background-color: white !important;
  /* height: 1.8rem; */
  font-size: x-small;
}

/* .vdp-datepicker__calendar {
  position: fixed;
  top: auto;
} */
.form-z .vdp-datepicker {
  position: initial !important;
}

.time-horizon-cs {
  padding: 0px 4px 0px 4px !important;
}

.v-select {
  width: 100%;
  margin-left: 10px;
}

.txt-fmt {
  font-size: small;
}

.dropdown-menu {
  font-size: small;
}

.new-tbl-cs {
  appearance: none;
  border: 1px solid rgba(60, 60, 60, .26);
  border-radius: 4px;
  white-space: normal;
  height: 1.5rem;
  width: 100%;
  height: 1.9rem;
  padding: 0 6px;
}

.new-tbl-aaa-cs {
  appearance: none;
  border: 1px solid rgba(60, 60, 60, .26);
  border-radius: 4px;
  white-space: normal;
  height: 1.5rem;
  width: 100%;
  height: 1.9rem;
  padding: 0 6px;
  margin: 3px 0 3px;
}

.user-profiling label {
  margin-bottom: 0;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/user-portfolio-analysis.vue